import BackModel from '../ModelBack'
import '../../style/model.css';
import { useRef, useEffect } from 'react'
import { CloseOutlined } from '@ant-design/icons'
const Model = ({ active, children, header, closeModel, zIndex }) => {
    const innerModelRef = useRef()
    useEffect(() => {
        
    }, [active])
    return (
        <BackModel active={active} closeModel={closeModel} zIndex={zIndex}>
            <div className={`containerAF inner-model-box ${active ? "activated" : ""}`} ref={innerModelRef} onClick={(e) => e.stopPropagation()}>
                <CloseOutlined style={{float: 'right', cursor: 'pointer'}} onClick={() => closeModel()} />
                <div className="inner-model header">{header}</div>
                <div className="content" style={{paddingBottom: '0px'}}>
                    {children}
                </div>
            </div>
        </BackModel>
    )
}
export default Model
// {/* <div className="actions">
//                     <div className="ui positive right labeled icon button" onClick={props.modelSuccess}>
//                         {props.successButton}
//                         <i className="checkmark icon"></i>
//                     </div>
//                     <div className="ui black deny button" onClick={closeModel}>{props.cancelButton}</div>
//                 </div> */}


//{/* // return (
//     <div className={`ui dimmer models ${props.active ? "visible active" : ""}`} style={{position: 'fixed'}}>
//         <div className={`ui standard modal ${props.active ? "visible active" : ""}`}>
//             <div className="header">{props.header}</div>
//                 <div className="content">
//                     {props.children}
//                 </div>
//         </div>
//     </div>,
//     document.getElementById('model-main')
// ) */}